export enum NewsTypes {
    national = "National", 
    regional="Regional",
    property="Property",
  }